import React from "react";
import bag from "../../assets/icons/bag.png";
import styled from "styled-components";
import fipayFonts from "../../theme/index";

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  border-radius: 12px;
  border-collapse: collapse;
  width: 100%;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    width: 327px;
    .amount,
    .quantity {
      display: none;
    }
  }
`;

const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;

const TableHeaderCell = styled.div`
  flex: 1;
  text-align: center;
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  color: #868686;
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  border-bottom: 1px solid #ddd;

  &:nth-child(3) {
    background-color: #f5f5f5;
  }
`;

const TableCell = styled.div`
  flex: 1;
  text-align: center;
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
`;

const ProductImage = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 10px;
`;

const TableData = [
  {
    productImage: "/assets/icons/bag.png",
    productName: "Louisana Bag",
    amount: "$200",
    quantity: 1,
  },
  {
    productImage: "/assets/icons/bag.png",
    productName: "Louisiana Bag",
    amount: "$200",
    quantity: 1,
  },
];

interface DataProps {
  storageData?: any;
}

const Product: React.FC<DataProps> = ({
  storageData,
}: {
  storageData?: any;
}) => {
  return (
    <TableContainer>
      <TableHeader>
        <TableHeaderCell>Product</TableHeaderCell>
        <TableHeaderCell>Product Name</TableHeaderCell>
        <TableHeaderCell className="amount">Amount</TableHeaderCell>
        <TableHeaderCell className="quantity">Quantity</TableHeaderCell>
      </TableHeader>
      <TableRow>
        <TableCell>
          <ProductImage src="/assets/icons/bag.png" alt="Product Image" />
        </TableCell>
        <TableCell>{storageData?.name}</TableCell>
        <TableCell className="amount">${storageData?.price}</TableCell>
        <TableCell className="quantity">2</TableCell>
      </TableRow>
      {/* <div>{storageData}</div> */}
    </TableContainer>
  );
};

export default Product;
